import { render, staticRenderFns } from "./ProveedorList.vue?vue&type=template&id=2c52957a&scoped=true&"
import script from "./ProveedorList.vue?vue&type=script&lang=js&"
export * from "./ProveedorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52957a",
  null
  
)

export default component.exports